window.theme = window.theme || {};
window.theme.countrySizing = [
  { 
    "name":"Australia", 
    "sizes": ["6", "8/10", "8/10", "10/12", "12/14", "14/16", "16/18","18/20"] 
  },
  { 
    "name":"Belgium", 
    "sizes": ["32/34", "34/36", "36/38", "40/42", "42/44", "44/46", "46/48"] 
  },
  { 
    "name":"France", 
    "sizes": ["34/36", "36/38", "40/42", "44/46", "46/48", "48/50", "50/52"] 
  },
  { 
    "name":"Spain",
    "sizes": ["34/36", "36/38", "40/42", "44/46", "46/48", "48/50", "50/52"] 
  },
  { 
    "name":"New Zealand",
    "sizes": ["6", "8/10", "10/12", "12/14", "14/16", "16/18", "18/20"] 
  },
  { 
    "name":"UK",
    "sizes": ["6", "8/10", "10/12", "12/14", "14/16", "16/18", "18/20"] 
  },
  { 
    "name":"Germany",
    "sizes": ["32/34", "34/36", "36/38", "40/42", "42/44", "44/46", "46/48"] 
  },
  { 
    "name":"Netherlands",
    "sizes":  ["32/34", "34/36", "36/38", "40/42", "42/44", "44/46", "46/48"] 
  },
  { 
    "name":"Switzerland",
    "sizes":  ["32/34", "34/36", "36/38", "40/42", "42/44", "44/46", "46/48"] 
  },
  { 
    "name":"Sweden",
    "sizes": ["32/34", "34/36", "36/38", "40/42", "42/44", "44/46", "46/48"] 
  },
  { 
    "name":"Norway",
    "sizes": ["32/34", "34/36", "36/38", "40/42", "42/44", "44/46", "46/48"] 
  },
  { 
    "name":"China",
    "sizes": ["165/88Y", "170/92Y", "170/96Y", "170/100Y", "170/104Y", "", ""] 
  },
  { 
    "name":"Italy",
    "sizes": ["40", "42/44", "46", "48/50", "50/52", "52/54", "54/56"] 
  },
  { 
    "name":"Hong Kong",
    "sizes": ["6", "8/10", "10/12", "12/14", "14/16", "16/18", "18/20"] 
  },
  { 
    "name":"US/Canada",
    "sizes": ["0/2", "2/4", "6/8", "8/10", "10/12", "12/14", "16/18"] 
  },
  { 
    "name":"Japan",
    "sizes": ["5/7", "7/9", "9/11", "11/13", "13/15", "17", "19"] 
  },
  { 
    "name":"UAE",
    "sizes": ["40", "42/44", "46", "48/10", "50/52", "52/54", "54/56"] 
  },
  { 
    "name":"Russia",
    "sizes": ["40", "42/44", "46", "48/10", "50/52", "52/54", "54/56"] 
  },
  { 
    "name":"Austria",
    "sizes": ["32/34", "34/36", "36/38", "40/42", "42/44", "44/46", "46/48"] 
  },
  { 
    "name":"Denmark",
    "sizes": ["32/34", "34/36", "36/38", "40/42", "42/44", "44/46", "46/48"] 
  },
  { 
    "name":"Israel",
    "sizes": ["34/36", "36/38", "40/42", "44/46", "46/48", "48/50", "50/52"] 
  },
  { 
    "name":"Portugal",
    "sizes": ["34/36", "36/38", "40/42", "44/46", "46/48", "48/50", "50/52"] 
  }
];
theme.countrySizingShoes = [
  { 
    "name":"EU",
    "sizes": ["36", "37", "38", "39", "40", "41"] 
  },
  { 
    "name":"US/Canada",
    "sizes": ["5", "6", "7", "8", "9", "10"] 
  }
];
theme.countrySizingMens = [
  { 
    "name":"EU",
    "sizes": ["28", "30", "30", "34", "36", "38"] 
  },
  { 
    "name":"US/Canada",
    "sizes": ["28", "30", "30", "34", "36", "38"] 
  }
];

theme.sizeChart = theme.countrySizing;

theme.countryList = function(t) {
  const countryListActual = document.getElementById('country-selector');
  if (!countryListActual) return;

  countryListActual.innerHTML = '';
  let sizingArr = theme.countrySizing;
  
  switch(t) {
    case 'Shoes':
      sizingArr = theme.countrySizingShoes;
      break;
    case 'Mens':
      sizingArr = theme.countrySizingMens;
      break;
  }
  
  theme.sizeChart = sizingArr;
  
  sizingArr.forEach(country => {
    const option = document.createElement('option');
    option.value = country.name;
    option.textContent = country.name;
    countryListActual.appendChild(option);
  });
  
  countryListActual.value = 'US/Canada';
}

theme.sizeGuideInit = function() {
  const countrySelector = document.getElementById('country-selector');
  const measurementSelector = document.getElementById('measurement-selector');
  const sizeGuideRoot = document.getElementById('size-guide');

  // Required interactive Size Guide UI is absent on fit-size-guide pages
  // (sidebar + page content only) and before modal AJAX content loads.
  if (!sizeGuideRoot || !countrySelector || !measurementSelector) return;
  if (sizeGuideRoot.dataset.sizeGuideInitialized === 'true') return;
  sizeGuideRoot.dataset.sizeGuideInitialized = 'true';

  countrySelector.addEventListener('change', function() {
    updateTabSizes();
  });

  measurementSelector.addEventListener('change', function(e) {
    const val = e.target.value;
    const tabs = document.querySelectorAll('.size-guide__tab');
    tabs.forEach(tab => {
      const cols = tab.querySelectorAll('td');
      cols.forEach((td) => {
        const cellText = td.innerHTML;
        if(cellText.indexOf('-') > -1 || td.classList.contains('in-cm')) {
          const cellValues = cellText.split('-');
          cellValues.forEach((n,i) => {
            if(isNaN(n)) return true;
            if(val === 'cm') {
              cellValues[i] = theme.inToCm(n);
              if (td.getAttribute("data-inches") === null) {
                td.setAttribute('data-inches',cellText);
              }
            } else {
              cellValues[i] = td.getAttribute('data-inches');
            }
          });
          td.innerHTML = cellValues.join('-');
        }
      });
    });
  });

  document.querySelectorAll('.size-guide__link').forEach((link) => {
    link.addEventListener('click',function(e) {
      e.preventDefault();
      const el = e.target;
      const panelId = el.getAttribute('aria-controls');
      const panel = document.getElementById(panelId);
      if (!panel) return;

      document.querySelectorAll('.size-guide__link').forEach((links) => {
        links.classList.remove('active');
      });
      document.querySelectorAll('.size-guide__tab').forEach((panels) => {
        panels.classList.add('hidden');
      });
      panel.classList.remove('hidden');
      el.classList.add('active');

      theme.countryList(el.textContent.trim());
    });
  });

  document.querySelectorAll('.countries-list').forEach(selector => {
    selector.addEventListener('click',function(e) {
      e.preventDefault();
      const myContent = selector.querySelector('.countries-list__content');
      if (myContent) myContent.classList.remove('hidden');
    });
  });

  document.querySelectorAll('.countries-list__actual .inactive-country').forEach(country => {
    country.addEventListener('click',function(e) {
      e.preventDefault();
      const list = country.closest('.countries-list');
      const myContent = list && list.querySelector('.countries-list__content');
      if (myContent) myContent.classList.remove('hidden');
    });
  });

  const productType = window.productJSON && window.productJSON.type;
  if(productType) {
    document.querySelectorAll('.size-guide__link').forEach(sizeLink => {
      const myTypes = sizeLink.getAttribute('data-product-types') || '';
      if(myTypes.indexOf(productType) === -1) return true;
      sizeLink.click();
    });
  }
};



//var csv is the CSV file with headers
function csvJSON(csv) {
  var lines = csv.split("\n");
  var result = [];
  var headers = lines[0].split(",");
  for(var i=1;i<lines.length;i++){
    var obj = {};
    var currentline=lines[i].split(",");
    for(var j=0;j<headers.length;j++){
      obj[headers[j]] = currentline[j];
    }
    result.push(obj);
  }
  return result; //JSON
}
const googleUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQXy3Zbc_iPp-tu5aoJyiac6GvZ3BLAEQV2aVzJf0ImoVS8CWIIOZypErbjSg5SNa22O0yY-ulevfjc/pub?output=csv'

function fetchSheet(url,panelId) {
  fetch(url)
  .then(response => response.text())
  .then((data) => {
    const sgJson = csvJSON(data);
    const panel = document.getElementById(panelId);
    const table = document.createElement('table');
    table.setAttribute('width','100%');
    const headersHtml = Object.keys(sgJson[0]).map(h => `<th>${h}</th>`).join('');
    const tableHtml = sgJson.map(row => {
      const columns = Object.values(row);
      const columnsInTable = columns.map(c => `<td>${c}</td>`).join('')
      return `<tr>${columnsInTable}</tr>`;
    }).join('');
    table.innerHTML = [headersHtml,tableHtml].join('');
    panel.appendChild(table);
    panel.classList.add('is-loaded');
    updateTabSizes();
  })
  .catch((error) => {
    console.error("Error:", error);
  });
}

function updateTabSizes() {
  const countrySelector = document.getElementById('country-selector');
  if (!countrySelector) return;

  const countryValue = countrySelector.value;
  document.querySelectorAll('.size-guide__tab').forEach(tab => {
    const table = tab.querySelector('table');
    if(!table) return;
    const firstRow = table.querySelectorAll('tr')[1];
    if (!firstRow) return;
    const firstCell = firstRow.querySelectorAll('td')[0];
    if (firstCell) firstCell.innerHTML = countryValue;
    theme.sizeChart.forEach((country) => {
      if(country.name == countryValue) {
        firstRow.querySelectorAll('td').forEach((td,i) => {
          if(i==0) return true;
          td.innerHTML = country.sizes[i-1];
		});
      }
    });
  });
}

function bootSizeGuide() {
  if (window.location.href.indexOf('/pages/size-guide') === -1) return;
  theme.sizeGuideInit();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootSizeGuide);
} else {
  bootSizeGuide();
}